module.exports = __webpack_public_path__ + "img/tpc-7.2828cac0.webp";